import { render, staticRenderFns } from "./FacilitiesStatistics.vue?vue&type=template&id=2f65fd81&scoped=true&"
import script from "./FacilitiesStatistics.vue?vue&type=script&lang=ts&"
export * from "./FacilitiesStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./FacilitiesStatistics.vue?vue&type=style&index=0&id=2f65fd81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65fd81",
  null
  
)

export default component.exports